var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPinkExclamationRed = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "#E41111"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M8.333 4.167h3.334l-.834 7.5h-1.67z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 15,
  r: 1.667,
  fill: "#FFF"
}))));
export default SvgPinkExclamationRed;